// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"238":"d0a4cc1d","297":"d0a4cc1d"}[chunkId] + ".chunk.css";
};